"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1581.176 1750.588c0 31.06-25.411 56.47-56.47 56.47H395.294c-31.059 0-56.47-25.41-56.47-56.47V564.706H225.882v1185.882c0 93.403 76.01 169.412 169.412 169.412h1129.412c93.402 0 169.412-76.01 169.412-169.412V564.706h-112.942v1185.882zm-903.529-169.412h112.941V677.647h-112.94v903.53zm451.765 0h112.94V677.647h-112.94v903.53zm211.211-1242.352L1217.065 0H694.6L571.268 338.824H.01v112.94h1920v-112.94h-579.388zm-649.299 0l82.334-225.883h364.462l82.334 225.883h-529.13z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTrash =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconTrash, _Component);

  function IconTrash() {
    (0, _classCallCheck2.default)(this, IconTrash);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconTrash).apply(this, arguments));
  }

  (0, _createClass2.default)(IconTrash, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconTrash",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconTrash.displayName = "IconTrash";
  return IconTrash;
}(_react.Component);

exports.default = IconTrash;
IconTrash.glyphName = 'trash';
IconTrash.variant = 'Line';
IconTrash.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);